import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';

const resources = [
  {
    title: 'Учебник по математике',
    description: 'Полный учебник для старших классов.',
    imageUrl: '/images/math-textbook.jpg',
    link: '/resources/math-textbook'
  },
  {
    title: 'Методология обучения',
    description: 'Современные методы обучения для учителей.',
    imageUrl: '/images/teaching-methods.jpg',
    link: '/resources/teaching-methods'
  },
  {
    title: 'Ресурсы для студентов',
    description: 'Подборка ресурсов для подготовки студентов.',
    imageUrl: '/images/student-resources.jpg',
    link: '/resources/student-resources'
  },
  // Add more resources as needed
];

export default function PCK() {
  return (
    <Container maxWidth="lg" sx={{ mt: 5 }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 4 }}>
        Учебно-методические ресурсы
      </Typography>

      <Grid container spacing={4}>
        {resources.map((resource, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image={resource.imageUrl}
                alt={resource.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h6" component="div">
                  {resource.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {resource.description}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={() => window.location.href = resource.link}
                >
                  Перейти
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
